if (!customElements.get('home-video-gallery')) {
  customElements.define('home-video-gallery', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.track = this.querySelector('.hvg__track');
      this.videos = [...this.querySelectorAll('video')];
      this.update = () => {
        const { scrollLeft, scrollWidth, clientWidth } = this.track;
        const max = Math.max(0, scrollWidth - clientWidth);
        const ratio = Math.min(1, clientWidth / scrollWidth);
        const rail = this.querySelector('.hvg__rail span');
        rail.style.width = `${ratio * 100}%`;
        rail.style.transform = `translateX(${max ? (scrollLeft / max) * (1 / ratio - 1) * 100 : 0}%)`;
        this.querySelector('[data-step="-1"]').disabled = scrollLeft <= 1;
        this.querySelector('[data-step="1"]').disabled = scrollLeft >= max - 1;
      };
      this.track.addEventListener('scroll', this.update, { ...options, passive: true });
      this.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => {
        const card = this.track.querySelector('.hvg__card');
        const distance = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).gap);
        this.track.scrollBy({ left: distance * Number(button.dataset.step), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }, options));
      this.videos.forEach(video => {
        const button = video.parentElement.querySelector('.hvg__play');
        const error = video.parentElement.querySelector('.hvg__error');
        button.addEventListener('click', async () => {
          error.hidden = true;
          if (!video.dataset.loaded) {
            video.querySelectorAll('source').forEach(source => { source.src = source.dataset.src; });
            video.dataset.loaded = 'true';
            video.load();
          }
          try { video.controls = true; await video.play(); }
          catch { button.hidden = false; error.hidden = false; }
        }, options);
        video.addEventListener('play', () => {
          this.videos.forEach(other => { if (other !== video) other.pause(); });
          button.hidden = true;
        }, options);
        video.addEventListener('ended', () => { video.controls = false; button.hidden = false; }, options);
        video.addEventListener('error', () => { error.hidden = false; button.hidden = false; }, options);
      });
      this.visibility = new IntersectionObserver(entries => entries.forEach(entry => {
        if (!entry.isIntersecting) entry.target.pause();
      }), { threshold: 0.1 });
      this.videos.forEach(video => this.visibility.observe(video));
      document.addEventListener('visibilitychange', () => { if (document.hidden) this.videos.forEach(video => video.pause()); }, options);
      document.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('.hvg__card');
        if (card && this.contains(card)) this.track.scrollTo({ left: card.offsetLeft - this.track.firstElementChild.offsetLeft, behavior: 'instant' });
      }, options);
      this.resize = new ResizeObserver(this.update);
      this.resize.observe(this.track);
      this.update();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
      this.visibility?.disconnect();
      this.videos?.forEach(video => video.pause());
    }
  });
}
